<template>
  <div class="slider-container">
    <VueSlider
      class="slider-container__slider"
      :modelValue="props.value"
      @update:modelValue="newValue => emit('update:value', newValue)"
      tooltip="always"
      :data="sliderSteps"
      data-value="id"
      data-label="name"
      :tooltip-style="props.isWithTooltip ? {} : { display: 'none' }"
      adsorb
      :contained="true"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, watch } from "vue";

// Components
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

const props = withDefaults(
  defineProps<{
    min: number;
    max: number;
    value: number;
    isWithTooltip?: boolean;
  }>(),
  {
    min: 1,
    max: 10,
    value: 5,
    isWithTooltip: true,
  }
);

const emit = defineEmits<{
  (e: "update:value", value: number): void;
}>();

// Slider steps ===============================================================
const sliderSteps = computed<Array<{ id: number; name: string }>>(() => {
  return [...new Array(props.max - props.min + 1)].map((_, index) => ({ id: props.min + index, name: `${props.min + index}` }));
});
</script>

<style scoped lang="scss">
// Slider container ===========================================================
.slider-container {
  width: 250px;
  height: 50px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  &__slider {
    width: 250px;

    :deep(.vue-slider-dot-handle-focus) {
      outline: 4px #fff solid;
      outline-offset: -1px;
      box-shadow: none;
      box-shadow: 0 1px 3px 5px rgba(0, 0, 0, 0.2);
    }
    :deep(.vue-slider-process) {
      height: 6px;
      background: transparent;
    }
    :deep(.vue-slider-process::before) {
      content: "";
      width: calc(100% + 14px);
      height: 100%;
      border-radius: 100px;
      position: absolute;
      inset: 0 auto auto -7px;
      background: rgba(21, 118, 124, 1);
    }
    :deep(.vue-slider-rail) {
    }
    :deep(.vue-slider-dot-tooltip-inner-top) {
      font-weight: bold;
      font-family: sans-serif;
      background: black;
    }
    :deep(.vue-slider-dot-tooltip-inner-top:after) {
      border-top-color: black;
    }
    :deep(.vue-slider-mark-step) {
      background: transparent;
    }
    :deep(.vue-slider-mark-label) {
      top: -38px;
      color: rgba(0, 0, 0, 0.4);
      font-family: sans-serif;
    }
    :deep(.vue-slider-mark) {
      opacity: 0;
    }
    :deep(.vue-slider-mark:first-child) {
      opacity: 1;
    }
    :deep(.vue-slider-mark:last-child) {
      opacity: 1;
    }

    :deep(.vue-slider-rail) {
      height: 6px;
      background: transparent;
    }
    :deep(.vue-slider-rail::before) {
      content: "";
      width: calc(100% + 14px);
      height: 100%;
      border-radius: 100px;
      position: absolute;
      inset: 0 auto auto -7px;
      background: rgba(217, 217, 217, 1);
    }
  }
}
</style>
